import { Model } from "@tailflow/laravel-orion/lib/model";

export class Catalog extends Model {
    $resource(): string {
        return "module/catalog";
    }
}
